export default __webpack_public_path__ + "static/media/41.a2bc9aba.jpg";